import { alpha, Box, Stack, Typography, useTheme } from "@mui/material";
import SectionShell from "../../../../component/courseDetailSection/SectionShell";
import { getCourseGlassSurfaceSx } from "../../../../component/courseDetailSection/const/surface";

export type CourseContentGridItem = Readonly<{
  title: string;
  description: string;
}>;

export type CourseContentGridSectionProps = Readonly<{
  title: string;
  items: CourseContentGridItem[];
}>;

export default function CourseContentGridSection({ title, items }: CourseContentGridSectionProps) {
  const theme = useTheme();

  return (
    <SectionShell title={title}>
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(3, minmax(0, 1fr))" }, gap: 3 }}>
        {items.map((item, index) => (
          <Stack
            key={item.title}
            spacing={2}
            sx={{
              position: "relative",
              minHeight: { xs: 220, md: 300 },
              p: { xs: 2.5, md: 3 },
              overflow: "hidden",
              ...getCourseGlassSurfaceSx(theme),
              "&::before": {
                content: '""',
                position: "absolute",
                inset: 0,
                height: 3,
                bgcolor: alpha(theme.palette.info.main, 0.8),
              },
            }}
          >
            <Typography variant="body2" sx={{ color: alpha(theme.palette.info.light, 0.86) }}>
              {String(index + 1).padStart(2, "0")}
            </Typography>
            <Typography variant="h5" color="primary.contrastText">
              {item.title}
            </Typography>
            <Typography variant="body1" sx={{ color: alpha(theme.palette.primary.contrastText, 0.74) }}>
              {item.description}
            </Typography>
          </Stack>
        ))}
      </Box>
    </SectionShell>
  );
}

